import { CodesOrSlugsResponse } from '@/app/(main)/(pages)/busca/[slug]/_types/codes-or-slugs-response.type';
import { restApiClient } from '@/datasources';
import { createTimeoutSignal } from '@/utils/api/timeout-signal';
import { searchRequestTimeoutMs } from '@/utils/consts/search-schedules.consts';

export async function getProceduresBySlugs(
  slug: string,
  searchParams?: { [key: string]: string | string[] | undefined },
): Promise<CodesOrSlugsResponse> {
  const options = { signal: createTimeoutSignal(searchRequestTimeoutMs) };

  if (['exames-laboratoriais', 'vacina'].includes(slug)) {
    const examesParam = searchParams?.exames;
    const codesOrSlugs = Array.isArray(examesParam) ? examesParam : examesParam?.split(',');

    const { data } = await restApiClient.get<CodesOrSlugsResponse>(
      'online/procedures/codes-or-slugs/',
      { codesOrSlugs },
      options,
    );

    return data;
  }

  const { data } = await restApiClient.get<CodesOrSlugsResponse>(
    'online/procedures/codes-or-slugs/',
    { codesOrSlugs: [slug] },
    options,
  );

  return data;
}
